module.exports = __webpack_public_path__ + "static/media/flag-as.2d8273e1.webp";